import React from 'react';

import { VIEW_TO_PATH } from '../../../routes';
import { useApp } from '../../../store/AppContext';
import { clientColor } from '../../../utils/phases';
import PhaseProgress from './PhaseProgress';

/* Cellule nom d'une phase : projet · phase (lien vers le projet), badge « en cours », planifié /
   consommé / vendu, jauge et dates. Bande et fond teintés à la couleur du projet. */
export default function ProjectNameCell({ client, ph, isActive, metrics, datesTxt, style }) {
  const { navigate, setSelectedClient, appState } = useApp();
  const clientCol = clientColor(appState.clients, client.id);
  return (
    <div style={style}>
      {/* Filigrane : bande + fond teinté à la couleur du projet */}
      <div
        className="absolute left-[0] top-[0] bottom-[0] w-[4px]"
        style={{ background: clientCol }}
      />
      <div
        className="absolute [inset:0] opacity-[0.06] [pointer-events:none]"
        style={{ background: clientCol }}
      />
      <div className="relative h-full flex flex-col justify-center gap-[3px] pt-[8px] pr-[12px] pb-[8px] pl-[16px]">
        <div
          className="text-[12.5px] font-bold text-navy whitespace-nowrap overflow-hidden [text-overflow:ellipsis] cursor-pointer [text-underline-offset:2px]"
          style={{ textDecoration: 'underline', textDecorationColor: 'rgba(2,56,72,0.25)' }}
          onClick={() => {
            setSelectedClient(client.id);
            navigate(VIEW_TO_PATH.projets);
          }}
        >
          {`${client.nom} · ${ph.nom || 'Phase'}`}
          {isActive && (
            <span className="text-[8px] font-bold text-success ml-[6px] [vertical-align:middle]">
              ● EN COURS
            </span>
          )}
        </div>
        <PhaseProgress {...metrics} />
        {datesTxt && (
          <div className="text-[10px] text-[#999] whitespace-nowrap overflow-hidden [text-overflow:ellipsis]">
            {datesTxt}
          </div>
        )}
      </div>
    </div>
  );
}
